import { api_get } from '@lf/api-client/lfApi';

export async function getUserProfile(setError = null) {
    const response = await api_get('/user/profile', undefined, setError);
    if (response && response.status === 200) {
        return response.data;
    }
    return null;
}
